<template>
	<div class="page-index-mobile column-me row-center" v-if="isMobile"></div>
	<div ref="carouselFull" class="page-index column-me row-center" v-else>
		<div class="all">
			<toubu></toubu>
			<div class="one"></div>
			<div class="two">
				<img src="../../assets/fuwuimg/bannerc.png" class="bannerc" />
				<div class="getBack" @click="getBack()">
					<img src="../../assets/fuwuimg/icon_weizhi.png">
					<div>成功案例 > <span>案例详情</span></div>
				</div>
				<div class="title">
					{{exampleInfo.name}}
				</div>

				<div class="exampleImg" v-if="exampleImg.length > 0" v-for="i in exampleImg" :key="i">
					<img :src="i">
				</div>
				<!-- <div class="two1">
          案例展示
        </div>
        <div class="two2">
          <div class="two22"></div>
          <div class="two21"></div>
          <div class="two23"></div>
        </div>
        <div class="two3">
          CASE SHOW
        </div> -->
				<!-- <div class="two4">
          <img class="two41" src="../../assets/chenggong/lieche.png" />
          <div class="two42">
            <div></div>
            <div>
              中车集团介绍内容中车集团介绍内容中车集团介绍内容中车集团介绍内
              容中车集团介绍内容中车集团介绍内容中车集团介绍内容中车集团介绍
              内容中车集团介绍内容中车集团介绍内容中车集团介绍内容中车集团介
              绍内容中车集团介绍内容中车集团介绍内容中车集团介绍内容中车集团
              介绍内容中车集团介绍内容中车集团介绍内容中车集团介绍内容中车集
            </div>
          </div>
        </div>
        <div class="two1">
          主要功能
        </div>
        <div class="two2">
          <div class="two22"></div>
          <div class="two21"></div>
          <div class="two23"></div>
        </div>
        <div class="two3">
          Major Function
        </div>
        <div class="two5">
          <div v-for="i in gongneng" :key="i" class="two51">
            <div class="two511">{{ i }}</div>
          </div>
        </div>
 -->
				<!-- <div class="two1">
          页面展示
        </div>
        <div class="two2">
          <div class="two22"></div>
          <div class="two21"></div>
          <div class="two23"></div>
        </div>
        <div class="two3">
          Major Function
        </div>
        <div class="two6">
          <div class="two61">
            <div class="two611" v-if="yuanxing" @click="yuanxing = true">
              原型图
            </div>
            <div class="two612" v-if="!yuanxing" @click="yuanxing = true">
              原型图
            </div>
            <div class="two611" v-if="!yuanxing" @click="yuanxing = false">
              设计图
            </div>
            <div class="two612" v-if="yuanxing" @click="yuanxing = false">
              设计图
            </div>
          </div>
        </div>
		 -->
			</div>
			<dibu></dibu>
		</div>
		<div class="crestBox pointer" @click="crestCick()" v-if="isVisable == true">
			<img src="../../assets/img/return.svg" />
		</div>
	</div>
</template>

<script>
	import Toubu from "@/components/header.vue";
	import Dibu from "@/components/footer.vue";
	export default {
		data() {
			return {
				isMobile: this.$store.state.isMobile === 1,
				gongneng: [
					"功能标签",
					"功能标签",
					"功能标签",
					"功能标签",
					"功能标签",
					"功能标签",
				],
				yuanxing: true,
				exampleInfo: '',
				exampleImg: [],
				isVisable: false,
			};
		},
		components: {
			Toubu,
			Dibu
		},
		computed: {
			windowChange() {
				return this.$store.state.isMobile;
			},
		},
		watch: {
			windowChange: function(newVal, oldVal) {
				this.isMobile = newVal === 1;
			},
		},
		created() {
			//添加滚动监听事件
			//在窗口滚动时调用监听窗口滚动方法
			window.addEventListener('scroll', this.windowScrollListener);
		},
		destroyed() {
			//离开页面时删除该监听
			window.removeEventListener('scroll', this.windowScrollListener)
		},
		methods: {
			//监听窗口滚动
			windowScrollListener() {
				//获取操作元素最顶端到页面顶端的垂直距离
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				if (scrollTop >= 1500) {
					this.isVisable = true; //大于1500时显示元素
				}
				if (scrollTop < 1500) {
					this.isVisable = false; //小于1500时隐藏元素
				}
			},
			crestCick() {
				//让页面滚动回到顶部
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			getBack() {
				window.history.go(-1);
			},
		},
		mounted() {
			let formData = new FormData();
			formData.append("id", this.$route.query.id);
			this.$post(this.$host + "/index/Example/exampleInfo", formData).then((res) => {
				console.log("案例详情", res);
				this.exampleInfo = res.data;
				this.exampleImg = res.data.example_img;

			});
		},
	};
</script>

<style lang="scss" scoped>
	.one {
		width: 100%;
		// height: 400px;
		// background-image: url("../../assets/chenggong/lieche.png");
		background-size: 100% 100%;
		display: flex;
	}

	.two {
		width: 100%;
		// height: 1200px;
		margin-bottom: 100px;
		.bannerc{
			width: 100%;
		}
		.getBack {
			width: 1316px;
			margin: 0 auto;
			margin-top: 49px;
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}

			div {
				font-size: 24px;
				color: #999999;

				span {
					color: #126CE7;
				}
			}
		}

		.title {
			margin: 0 auto;
			width: 1316px;
			text-align: center;
			font-size: 30px;
			color: #222222;
			padding-bottom: 49px;
			border-bottom: 1px solid #ececec;
			margin-bottom: 50px;
			margin-top: 46px;
		}

		.exampleImg {
			margin: 0 auto;
			width: 1316px;

			img {
				width: 100%;
			}
		}

		.two1 {
			text-align: center;
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			padding-top: 59px;
			padding-bottom: 23px;
			// margin-top: 59px;
		}

		.two2 {
			display: flex;
			justify-content: center;

			.two22 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-right: 1vw;
			}

			.two21 {
				width: 40px;
				height: 3px;
				background: #ffae67;
			}

			.two23 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-left: 1vw;
			}
		}

		.two3 {
			margin-top: 24px;
			display: flex;
			justify-content: center;
			color: rgba(0, 0, 0, 0.418);
		}

		.two4 {
			margin-top: 57px;
			display: flex;
			justify-content: center;

			.two41 {
				width: 30vw;
				height: 25vh;
			}

			.two42 {
				width: 558px;
				margin-left: 20px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				line-height: 36px;
			}
		}

		.two5 {
			display: flex;
			justify-content: center;

			.two51 {
				width: 130px;
				height: 40px;
				background: #f1993a;
				border-radius: 20px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #ffffff;
				text-align: center;
				line-height: 40px;
				margin-left: 40px;
				margin-top: 50px;
			}
		}

		.two6 {
			.two61 {
				display: flex;
				margin-top: 49px;
				justify-content: center;

				.two611 {
					width: 130px;
					height: 40px;
					background: #126ce7;
					border-radius: 20px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #ffffff;
					line-height: 40px;
					text-align: center;
					margin-left: 40px;
				}

				.two612 {
					width: 130px;
					height: 40px;
					background: white;
					border-radius: 20px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #ffffff;
					line-height: 40px;
					text-align: center;
					margin-left: 40px;
					border: 2px solid #126ce7;
					color: #126ce7;
				}
			}
		}
	}
</style>
